import {StatusStateName} from "helpers"
import {useAllAvailableStudentStatuses} from "hooks/student-statuses/useAllAvailableStudentStatuses"
import {orderBy, uniq} from "lodash"
import {useMemo} from "react"
import {Auth} from "types/auth"

type Options = {
    forState?: Auth.StudentState[]
    statusIds?: number[]
}

export const useGroupedStudentStatusesByStateAsDropdownOptions = ({forState, statusIds}: Options) => {
    const {statuses} = useAllAvailableStudentStatuses({forState})

    const groupedStatuses = useMemo(() => {
        const filteredStatuses = statusIds?.length
            ? statuses.filter((status) => statusIds.includes(status.statusId))
            : statuses

        const states = uniq(filteredStatuses.map((item) => item.state))

        return states
            .map((state) => {
                const options = orderBy(
                    filteredStatuses.filter((status) => status.state === state),
                    ["state", "priority"],
                    ["asc", "asc"]
                )

                return {
                    label: StatusStateName[state] ?? "WITHOUT STATE",
                    options
                }
            })
            .filter((group) => group.options.length > 0)
    }, [statuses, statusIds])

    return {statuses, groupedStatuses}
}
